import { render } from "./QuestionnaireObjectSetEdit.vue?vue&type=template&id=436174fc&scoped=true"
import script from "./QuestionnaireObjectSetEdit.vue?vue&type=script&lang=js"
export * from "./QuestionnaireObjectSetEdit.vue?vue&type=script&lang=js"

import "./QuestionnaireObjectSetEdit.vue?vue&type=style&index=0&id=436174fc&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436174fc"]])

export default __exports__